import { Command } from "src/app/shared/ddd/models/command";
import { FormFieldChange } from "src/app/items/components/item-form/dynamic-form-actions-base";

export class ScopeOfWorkFieldChangeCommand implements Command {
  fieldChange: FormFieldChange;

  constructor(fieldChange: FormFieldChange) {
    this.fieldChange = fieldChange;
  }
}
